module.exports = __webpack_public_path__ + "static/media/demo-clip.004f7504.mp4";